<!--
  File name: PassResetLink.vue
  Program Description:
    - This component is used when the user changes his/her password
    - Email notification would lead to this page in the system

  Includes:
    - PasswordForm: contains all the necessary fields to change the user password
-->
<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card
          class="elevation-12 px-5 pt-6 pb-12 rounded-lg"
          tile
          :loading="$data.$meta.isLoading"
        >
          <v-card-title
            class="title"
          >
            <h1 class="primary--text text-h3 font-weight-bold">
              Reset Password
            </h1>
          </v-card-title>
          <v-card-text>
            <PasswordForm
              ref="passwordForm"
              :can-edit="!$data.$meta.readOnly"
              v-bind="{ password, confirmPassword }"
              :is-reset-password="false"
              :loading="$data.$meta.isLoading"
              @change="$data[$event.key] = $event.value"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PasswordForm from '@/components/local/PasswordForm'
import { metaMixin } from '@/meta'
import password from '@/utils/webapi/password'
import { custom, validationMixin, validationErrors } from '@/utils/validations'
import { sameAs } from 'vuelidate/lib/validators'
export default {
  name: 'PassResetLink',
  components: {
    PasswordForm
  },
  mixins: [metaMixin, validationMixin],
  data: () => ({
    password: '',
    confirmPassword: '',
    $meta: {
      isLoading: false
    },
    $opts: {
      password: {
        show: false,
        showConfirm: false
      }
    }
  }),
  validations: {
    password: custom.password,
    confirmPassword: {
      sameAs: sameAs('password')
    }
  },
  computed: {
    ...validationErrors,
    isInvalid () {
      let invalid
      for (const form in this.$refs) {
        const ref = this.$refs[`${form}`]
        if (ref.$v && !invalid) {
          invalid = ref.$v.$invalid
        }
      }
      return invalid
    }
  },
  methods: {
    // submit new password for password change
    async resetPassword () {
      this.$v.password.$touch()
      if (this.password === '') {
        this.$store.dispatch('showAlert', {
          message: 'Please fill in required fields.',
          type: 'error'
        })
      }
      if (!this.$v.$invalid) {
        this.$data.$meta.isLoading = true
        const { query } = this.$route
        const resp = await password.emailChangePassword(query.username, query.otp, this.password)
        const jData = await resp.json()
        this.$data.$meta.isLoading = false
        if (resp.ok) {
          this.$store.dispatch('showAlert', {
            message: 'Your password has been changed successfully! Use your new password to Login.',
            type: 'success'
          })
          this.$router.push({ name: 'Login' })
        } else {
          this.$store.dispatch('showAlert', {
            message: jData.error || jData.message,
            type: 'error'
          })
        }
      }
      if (!this.$v.password.$invalid && this.$v.confirmPassword.$invalid) {
        this.$store.dispatch('showAlert', {
          message: 'Confirm your new password.',
          type: 'error'
        })
      }
    },
    // trigger validations for fields
    validate () {
      for (const form in this.$refs) {
        const ref = this.$refs[`${form}`]
        if (ref.$v) {
          ref.$v.$touch()
        }
      }
    }
  }
}
</script>
